import React, { useEffect, useState } from "react";
import Header from "../Include/Header";
import Navbar from "../Include/Navbar";
import Footer from "../Include/Footer";
// import poojaImg from "../Images/Rectangle 30.png";
import { useLocation, useNavigate } from "react-router-dom";
import { MdRemoveCircle } from "react-icons/md";
import { errorMessage, successMessage } from "../../Utils/notificationManger";
import axios from "axios";
import checkoutJson from "./Check.json"
import Metadata from "../../Meta/Metadata";

function CheckOut() {
  const { state } = useLocation()
  const [formFields, setFormFields] = useState([]);
  const [packages, setPackage] = useState();
  const [packageName, setPackageName] = useState("")
  const user = JSON.parse(localStorage.getItem("user"))
  const navigate = useNavigate()
  const location = useLocation()
  const lang = JSON.parse(localStorage.getItem("lang"))
  const user_id = JSON.parse(localStorage.getItem("user"))



  const initializeFormFields = (packageName) => {
    const cleanedPackageName = packageName.toLowerCase().match(/family/) ? 'family' : packageName.toLowerCase();

    console.log(cleanedPackageName);
    if (packageName === 'single') {
      setFormFields([{ name: '', gotra: user?.gotra, membercount: 1 }]);
    } else if (cleanedPackageName === 'couple') {
      setFormFields([{ name: '', gotra: user?.gotra, membercount: 1 }, { name: '', gotra: user?.gotra, membercount: 2 }]);
    } else if (cleanedPackageName === 'family') {
      setFormFields([{ name: '', gotra: user?.gotra, membercount: 1 }, { name: '', gotra: user?.gotra, membercount: 2 }, { name: '', gotra: user?.gotra, membercount: 3 }, { name: '', gotra: user?.gotra, membercount: 4 }]);
    }
  };


  const handleChange = (index, e) => {
    e.preventDefault()

    const newFormFields = [...formFields];
    newFormFields[index][e.target.name] = e.target.value;
    setFormFields(newFormFields);
  }

  const addFamilyMember = () => {
    setFormFields([...formFields, { name: '', gotra: user?.gotra, membercount: formFields?.length + 1 }]);
  };

  const removeFamilyMember = (index) => {
    const newFormFields = formFields.filter((_, i) => i !== index);
    setFormFields(newFormFields);
  };

  console.log(location);

  const createMembers = async () => {

    const payloads = {
      mamberDetails: formFields,
      cart_id: location?.state?.payload?.booking_id
    }

    if (user?.all_details_fillup == "0") {
      navigate("/profileDetails", { state: { payloadi: payloads } })
      return
    }

    try {


      // const formData = new FormData()
      // formData.append("cart_id", location?.state?.payload?.booking_id)
      // formData.append("memberDetails", JSON.stringify(formFields))
      const payload = {
        mamberDetails: formFields,
        cart_id: location?.state?.payload?.booking_id
      }
      const response = await axios.post("https://devkirpa.com/admin/api/couple-details", payload, { headers: { 'Content-Type': 'application/json' } })
      const data = await response?.data
      if (response?.status === 200) {
        successMessage("Members created Successfully" || data?.message)
        navigate("/order-confirmation", { state: { booking_id: location?.state?.payload?.booking_id } })
      }
    } catch (error) {
      errorMessage(error?.response?.data?.message)
    }
  }

  useEffect(() => {
    const filterPujaPlan = state?.payload?.pujaPlans?.filter(planId => planId?.id === state?.payload?.packageId)
    setPackage(filterPujaPlan[0])
    setPackageName(filterPujaPlan[0]?.name?.en?.toLowerCase());
    initializeFormFields(filterPujaPlan[0]?.name?.en?.toLowerCase())
  }, [state]);


  // console.log(formFields);

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])


  console.log("Secure Checkout page");
  return (
    <section>
       <Metadata
        title={`DEVKIRPA | Secure Checkout `}
        description="Devkirpa Checkout Page"
        url={`https://devkirpa.com/Checkout}`}
      />
      <Header />
      <Navbar />
      <div className="flex justify-center font-poppins">
        <div className="py-2 w-[84%] flex gap-4  max-sm:flex-col-reverse max-lg:flex-col-reverse">
          <div className="border-1 border-orange-600 rounded-lg w-[63.66%] p-4 max-sm:w-full  max-lg:w-full">
            <h1 className="text-3xl font-semibold">{lang === "hi" ? checkoutJson?.title?.en : checkoutJson?.title?.hi}</h1>
            <div className="flex justify-between items-center w-full">
              <h5 className="pt-4 pb-1 text-2xl font-semibold">{lang === "hi" ? checkoutJson?.subTitle?.en : checkoutJson?.subTitle?.hi}</h5>
              {packageName.toLowerCase().match(/family/) && 'family' == "family" && (
                <button type="button" onClick={addFamilyMember} className="py-2 mt-3  w-44 bg-orange-600 text-light rounded text-sm font-semibold">
                  {lang === "hi" ? checkoutJson?.addFamily?.en : checkoutJson?.addFamily?.hi}
                </button>
              )}
            </div>
            {
              formFields?.map((form, i) => {
                return (
                  <div className="w-full flex flex-col gap-2">
                    <div>
                      <div className="mt-2">
                        <h1 className="font-semibold">{lang === "hi" ? checkoutJson?.person?.en : checkoutJson?.person?.hi} {i + 1}</h1>
                      </div>
                      <div className="w-full flex gap-2 mt-2 justify-center items-center max-sm:flex-col max-lg:flex-col">
                        <div className="w-full flex flex-col gap-2">
                          <label htmlFor="">{lang === "hi" ? checkoutJson?.fullName?.en : checkoutJson?.fullName?.hi}</label>
                          <input type="text" name="name" id={`name-${i}`} className="border-2 border-black p-2 rounded-lg" placeholder="Type Full Name" onChange={(e) => handleChange(i, e)} value={form?.name} />
                        </div>
                        <div className="w-full flex flex-col gap-2 max-sm:flex-col max-lg:flex-col">
                          <label htmlFor="">{lang === "hi" ? checkoutJson?.gotraName?.en : checkoutJson?.gotraName?.hi}</label>
                          <input type="text" name="gotra" id={`gotra-${i}`} value={user?.gotra} readOnly className="border-2 border-black p-2 rounded-lg" placeholder="Type Gotra" />
                        </div>

                        {
                          packageName.toLowerCase().match(/family/) && 'family' == "family" && (
                            <button type="button" onClick={() => removeFamilyMember(i)} className="w-10 rounded-full h-10 text-2xl  text-red-600 mt-8 font-semibold max-sm:p-0 max-sm:flex max-sm:justify-end max-sm:items-end max-sm:w-full max-lg:w-full max-lg:flex max-lg:justify-end max-lg:items-end">
                              <MdRemoveCircle />
                            </button>
                          )}

                      </div>
                    </div>

                  </div>
                )
              })
            }

            <div className="pt-2 col-lg-6">
              <div className="py-2">
                <input
                  type="button"
                  value={lang === "hi" ? checkoutJson?.button?.en : checkoutJson?.button?.hi}
                  className="py-2  w-full bg-orange-600 text-light rounded text-sm font-semibold"
                  onClick={createMembers}
                />
              </div>
            </div>
          </div>


          <div className="border-1 border-orange-600 rounded-lg w-[36.33%] h-fit p-3 max-sm:w-full max-lg:w-full">
            <div>
              <h1 className="font-bold text-sm">{lang === "hi" ? checkoutJson?.review?.en : checkoutJson?.review?.hi}</h1>
              <div className="flex gap-2 py-4">
                <div className="w-52 h-32 ">
                  <img
                    src={state?.payload?.pujaDetails?.images[0]?.img_name}
                    alt=""
                    className="rounded-lg object-cover object-center w-full h-full"
                  />
                </div>
                <div className="w-full ml-2">
                  <div>
                    <h3 className="text-xl font-bold capitalize font-josefin">
                      {lang === "hi" ? state?.payload?.pujaDetails?.name?.en : state?.payload?.pujaDetails?.name?.hi}
                      {/* {state?.payload?.pujaDetails?.name?.en} */}
                    </h3>
                  </div>
                  <div className="flex items-center gap-2 py-1 justify-start">
                    <div className="w-10 h-10">
                      <img
                        src="/Logo.jpg"
                        alt="Logo"
                        className="w-full h-full object-fit object-center"
                      />
                    </div>
                    <div>
                      <h1 className="text-orange-600 text-sm font-bold">
                        {lang === "hi" ? checkoutJson?.devkirpa?.en : checkoutJson?.devkirpa?.hi}
                      </h1>
                    </div>
                  </div>

                </div>
              </div>
            </div>
            <div className="flex flex-col gap-3">
              <div className="flex gap-2 items-center">
                <svg
                  width="21"
                  height="20"
                  viewBox="0 0 21 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g id="Group" clip-path="url(#clip0_226_1336)">
                    <path
                      id="Vector"
                      d="M7.00912 9.99996C5.88412 10.0347 4.96398 10.4791 4.24869 11.3333H2.85287C2.28342 11.3333 1.80425 11.1927 1.41537 10.9114C1.02648 10.6302 0.832031 10.2187 0.832031 9.67705C0.832031 7.22566 1.26259 5.99996 2.12369 5.99996C2.16536 5.99996 2.3164 6.07288 2.57682 6.21871C2.83724 6.36455 3.17578 6.51212 3.59244 6.66143C4.00911 6.81073 4.42231 6.88538 4.83203 6.88538C5.29731 6.88538 5.75911 6.80552 6.21744 6.6458C6.18273 6.90274 6.16537 7.13191 6.16537 7.3333C6.16537 8.29857 6.44662 9.18746 7.00912 9.99996ZM18.1654 16.6354C18.1654 17.4687 17.9119 18.1267 17.4049 18.6093C16.898 19.092 16.2244 19.3333 15.3841 19.3333H6.27994C5.43967 19.3333 4.76606 19.092 4.25912 18.6093C3.75217 18.1267 3.49869 17.4687 3.49869 16.6354C3.49869 16.2673 3.51085 15.9079 3.53516 15.5573C3.55946 15.2066 3.60808 14.8281 3.68099 14.4218C3.75391 14.0156 3.84592 13.6388 3.95703 13.2916C4.06814 12.9444 4.21744 12.6059 4.40494 12.276C4.59244 11.9461 4.80772 11.6649 5.05078 11.4323C5.29384 11.1996 5.59071 11.0139 5.94141 10.875C6.2921 10.7361 6.67925 10.6666 7.10287 10.6666C7.17231 10.6666 7.32161 10.7413 7.55078 10.8906C7.77995 11.0399 8.03342 11.2066 8.31119 11.3906C8.58898 11.5746 8.96051 11.7413 9.42578 11.8906C9.89106 12.0399 10.3598 12.1145 10.832 12.1145C11.3043 12.1145 11.773 12.0399 12.2383 11.8906C12.7036 11.7413 13.0751 11.5746 13.3529 11.3906C13.6306 11.2066 13.8841 11.0399 14.1133 10.8906C14.3424 10.7413 14.4918 10.6666 14.5612 10.6666C14.9848 10.6666 15.372 10.7361 15.7227 10.875C16.0733 11.0139 16.3702 11.1996 16.6133 11.4323C16.8563 11.6649 17.0716 11.9461 17.2591 12.276C17.4466 12.6059 17.5959 12.9444 17.707 13.2916C17.8181 13.6388 17.9102 14.0156 17.9831 14.4218C18.056 14.8281 18.1046 15.2066 18.1289 15.5573C18.1532 15.9079 18.1654 16.2673 18.1654 16.6354ZM7.49869 3.3333C7.49869 4.06941 7.23828 4.69788 6.71744 5.21871C6.19661 5.73955 5.56814 5.99996 4.83203 5.99996C4.09592 5.99996 3.46745 5.73955 2.94662 5.21871C2.42578 4.69788 2.16537 4.06941 2.16537 3.3333C2.16537 2.59718 2.42578 1.96871 2.94662 1.44788C3.46745 0.927043 4.09592 0.666626 4.83203 0.666626C5.56814 0.666626 6.19661 0.927043 6.71744 1.44788C7.23828 1.96871 7.49869 2.59718 7.49869 3.3333ZM14.832 7.3333C14.832 8.43747 14.4414 9.38017 13.6602 10.1614C12.8789 10.9427 11.9362 11.3333 10.832 11.3333C9.72786 11.3333 8.78516 10.9427 8.00391 10.1614C7.22266 9.38017 6.83203 8.43747 6.83203 7.3333C6.83203 6.22913 7.22266 5.28642 8.00391 4.50517C8.78516 3.72392 9.72786 3.3333 10.832 3.3333C11.9362 3.3333 12.8789 3.72392 13.6602 4.50517C14.4414 5.28642 14.832 6.22913 14.832 7.3333ZM20.832 9.67705C20.832 10.2187 20.6376 10.6302 20.2487 10.9114C19.8598 11.1927 19.3806 11.3333 18.8112 11.3333H17.4154C16.7001 10.4791 15.7799 10.0347 14.6549 9.99996C15.2174 9.18746 15.4987 8.29857 15.4987 7.3333C15.4987 7.13191 15.4813 6.90274 15.4466 6.6458C15.905 6.80552 16.3668 6.88538 16.832 6.88538C17.2418 6.88538 17.655 6.81073 18.0716 6.66143C18.4883 6.51212 18.8268 6.36455 19.0872 6.21871C19.3477 6.07288 19.4987 5.99996 19.5404 5.99996C20.4015 5.99996 20.832 7.22566 20.832 9.67705ZM19.4987 3.3333C19.4987 4.06941 19.2383 4.69788 18.7174 5.21871C18.1966 5.73955 17.5681 5.99996 16.832 5.99996C16.0959 5.99996 15.4675 5.73955 14.9466 5.21871C14.4258 4.69788 14.1654 4.06941 14.1654 3.3333C14.1654 2.59718 14.4258 1.96871 14.9466 1.44788C15.4675 0.927043 16.0959 0.666626 16.832 0.666626C17.5681 0.666626 18.1966 0.927043 18.7174 1.44788C19.2383 1.96871 19.4987 2.59718 19.4987 3.3333Z"
                      fill="#F15A24"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_226_1336">
                      <rect
                        width="20"
                        height="20"
                        fill="white"
                        transform="translate(0.832031)"
                      />
                    </clipPath>
                  </defs>
                </svg>
                <h1 className="uppercase font-semibold text-sm">{lang === "hi" ? packages?.name?.en : packages?.name?.hi}</h1>
              </div>
              <div className="flex gap-2 items-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="25"
                  height="24"
                  viewBox="0 0 25 24"
                  fill="none"
                >
                  <path
                    d="M19.5898 3.5H17.5898V2.5C17.5898 2.23478 17.4845 1.98043 17.297 1.79289C17.1094 1.60536 16.8551 1.5 16.5898 1.5C16.3246 1.5 16.0703 1.60536 15.8827 1.79289C15.6952 1.98043 15.5898 2.23478 15.5898 2.5V3.5H9.58984V2.5C9.58984 2.23478 9.48449 1.98043 9.29695 1.79289C9.10941 1.60536 8.85506 1.5 8.58984 1.5C8.32463 1.5 8.07027 1.60536 7.88274 1.79289C7.6952 1.98043 7.58984 2.23478 7.58984 2.5V3.5H5.58984C4.79419 3.5 4.03113 3.81607 3.46852 4.37868C2.90591 4.94129 2.58984 5.70435 2.58984 6.5V18.5C2.58984 19.2956 2.90591 20.0587 3.46852 20.6213C4.03113 21.1839 4.79419 21.5 5.58984 21.5H19.5898C20.3855 21.5 21.1486 21.1839 21.7112 20.6213C22.2738 20.0587 22.5898 19.2956 22.5898 18.5V6.5C22.5898 5.70435 22.2738 4.94129 21.7112 4.37868C21.1486 3.81607 20.3855 3.5 19.5898 3.5ZM20.5898 18.5C20.5898 18.7652 20.4845 19.0196 20.297 19.2071C20.1094 19.3946 19.8551 19.5 19.5898 19.5H5.58984C5.32463 19.5 5.07027 19.3946 4.88274 19.2071C4.6952 19.0196 4.58984 18.7652 4.58984 18.5V11.5H20.5898V18.5ZM20.5898 9.5H4.58984V6.5C4.58984 6.23478 4.6952 5.98043 4.88274 5.79289C5.07027 5.60536 5.32463 5.5 5.58984 5.5H7.58984V6.5C7.58984 6.76522 7.6952 7.01957 7.88274 7.20711C8.07027 7.39464 8.32463 7.5 8.58984 7.5C8.85506 7.5 9.10941 7.39464 9.29695 7.20711C9.48449 7.01957 9.58984 6.76522 9.58984 6.5V5.5H15.5898V6.5C15.5898 6.76522 15.6952 7.01957 15.8827 7.20711C16.0703 7.39464 16.3246 7.5 16.5898 7.5C16.8551 7.5 17.1094 7.39464 17.297 7.20711C17.4845 7.01957 17.5898 6.76522 17.5898 6.5V5.5H19.5898C19.8551 5.5 20.1094 5.60536 20.297 5.79289C20.4845 5.98043 20.5898 6.23478 20.5898 6.5V9.5Z"
                    fill="#ED5826"
                  />
                </svg>
                <h1 className="text-sm font-semibold">{state?.payload?.pujaDetails?.duration} </h1>
              </div>
              <div className="flex gap-2 items-center">
                <svg
                  width="25"
                  height="24"
                  viewBox="0 0 25 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g id="cross-circle">
                    <path
                      id="primary"
                      d="M15.832 15L9.83204 9M9.83204 15L15.832 9M21.832 12C21.832 13.78 21.3042 15.5201 20.3153 17.0001C19.3263 18.4802 17.9207 19.6337 16.2762 20.3149C14.6317 20.9961 12.8221 21.1743 11.0762 20.8271C9.33039 20.4798 7.72675 19.6226 6.46807 18.364C5.2094 17.1053 4.35223 15.5016 4.00497 13.7558C3.6577 12.01 3.83593 10.2004 4.51712 8.55585C5.19831 6.91131 6.35186 5.50571 7.8319 4.51677C9.31195 3.52784 11.052 3 12.832 3C15.219 3 17.5082 3.94821 19.196 5.63604C20.8838 7.32387 21.832 9.61305 21.832 12Z"
                      stroke="#ED5826"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </g>
                </svg>
                <h1 className="font-semibold text-sm">{lang === "hi" ? checkoutJson?.nonRefundable?.en : checkoutJson?.nonRefundable?.hi}</h1>
              </div>

            </div>
            <div className="pt-5 flex justify-between">
              <p className="font-bold">{lang === "hi" ? checkoutJson?.total?.en : checkoutJson?.total?.hi}</p>
              <p className="font-bold text-orange-600">&#8377;{packages?.price}</p>
            </div>
            <div >
              <p className="text-xs flex justify-end">
                {lang === "hi" ? checkoutJson?.include?.en : checkoutJson?.include?.hi}
              </p>
            </div>

          </div>
        </div>
      </div>
      <Footer />
    </section>
  );
}

export default CheckOut;
